import {reactive} from "vue";

export function useWidgetNames() {

    const widgetNames = reactive({
        CRM_AVERAGE_DURATION: 'crm_average_duration',
        CRM_AVERAGE_DURATION_BY_OUTCOME: 'crm_average_duration_by_outcome',
        CRM_ESTIMATE_SALES_BY_PERIOD: 'crm_estimate_sales_by_period',
        CRM_ESTIMATE_STATUS_TURNOVER: 'crm_estimate_status_turnover',
        CRM_ESTIMATE_STATUS_TURNOVER_PERCENTAGE: 'crm_estimate_status_turnover_percentage',
        CRM_GET_AVERAGE_PAYMENT_DELAY: 'crm_get_average_payment_delay',
        CRM_GET_INVOICE_AND_ADVANCE_COUNT_STATISTIC: 'crm_get_invoice_and_advance_count_statistic',
        CRM_GET_OPPORTUNITIES_CONVERSION_RATE: 'crm_get_opportunities_conversion_rate',
        CRM_GET_TOP_ACTIVITIES_FOR_WON_OPPORTUNITIES: 'crm_get_top_activities_for_won_opportunities',
        CRM_GET_TOTAL_APPOINTMENT_BY_STATUS: 'crm_get_total_appointment_by_status',
        CRM_INVOICE_STAT_BY_STATUS: 'crm_invoice_stat_by_status',
        CRM_INVOICE_TURN_OVER: 'crm_invoice_turn_over',
        CRM_OPPORTUNITIES_BY_STAGE: 'crm_opportunities_by_stage',
        CRM_OPPORTUNITIES_TOTAL_BY_STATUS: 'crm_opportunities_total_by_status',
        CRM_SALES_BY_PERIODS: 'crm_sales_by_periods',
        CRM_TOP_CONTACTS: 'crm_top_contacts',
        CRM_TOP_CUSTOMER: 'crm_top_customer',
        CRM_TOP_OPPORTUNITIES_ESTIMATE_STAT: 'crm_top_opportunities_estimate_stat',
        CRM_TOP_OPPORTUNITIES_LOST_REASON: 'crm_top_opportunities_lost_reason',
        CRM_TOP_PRODUCT: 'crm_top_product',
        CRM_TOP_PROSPECTS: 'crm_top_prospects',
        CRM_TOP_TOTAL_APPOINTMENT_PER_CREATOR: 'crm_top_total_appointment_per_creator',
        PROJECT_USER_PERFORMANCE: 'project_user_performance',
      })


    return { widgetNames }
}
